import { useEffect } from 'react';
import PropTypes from 'prop-types';
import AOS from 'aos';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText, { fragment } from '../../Core/RichText';
import Link from '../../Core/Link';

import { Section, Grid, Headline, UL, Feature, Footer } from './styles';

const FeatureChecklist = ({ data }) => {
  if (!data) return null;

  const {
    anchorName,
    backgroundColor,
    contentAlignment,
    sectionContainerHeading,
    elements,
    ctas,
  } = data;

  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  const header = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Headline data-aos="fade-up" data-aos-duration="1000">
          {children}
        </Headline>
      ),
      [BLOCKS.HEADING_2]: (_, children) => (
        <Headline data-aos="fade-up" data-aos-duration="1000">
          {children}
        </Headline>
      ),
    },
  };

  return (
    <Section
      id={anchorName}
      backgroundColor={backgroundColor}
      contentAlignment={contentAlignment}
    >
      <Grid>
        <RichText document={sectionContainerHeading} options={header} />
        <UL data-aos="fade-up" data-aos-delay="250" data-aos-duration="1000">
          {elements.map(({ id, heading, iconDam }) => {
            return (
              <li key={id}>
                <Feature icon={iconDam.asset.localImage.publicURL}>
                  <RichText document={heading} />
                </Feature>
              </li>
            );
          })}
        </UL>
      </Grid>
      {ctas && (
        <Footer>
          {ctas.map(cta => {
            if (cta.hideFrench === true) return null;
            return (
              <Link key={cta.id} data={cta}>
                <RichText document={cta.label} options={fragment} />
              </Link>
            );
          })}
        </Footer>
      )}
    </Section>
  );
};

FeatureChecklist.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default FeatureChecklist;
